import React, { useEffect, useRef, useState } from 'react';

import { roundOffToPlaces } from 'constants/helper';

import InputLabel from 'uiToolkitV1/InputLabel';
import { InputV2 } from 'uiToolkitV1/InputV2';

const ERROR_MSG = 'This is a mandatory field';
export const GenericNumericInput = ({
  labelText = '',
  value = 0,
  onChange = () => {},
  onValueChange = () => {},
  isReadOnly,
  isMandatory = true,
  errorMessage = '',
}) => {
  const ref = useRef(null);
  const [localValue, setLocalValue] = useState(value);
  const [error, setError] = useState('');

  const hasError = error.length > 0;

  const safeOnChange = () => {
    const convertedLocalValue = `${roundOffToPlaces(localValue, 2)}`;
    setLocalValue(convertedLocalValue);
    if (!hasError) onChange(convertedLocalValue);
  };

  const onKeyDown = (ev) => {
    if (ev.key === 'Enter' && !hasError) {
      ref?.current?.blur();
    }
  };

  const handleLocalValueChange = (ev) => {
    const { target } = ev;

    setError(target?.value?.trim()?.length === 0 && isMandatory ? errorMessage || ERROR_MSG : '');
    onValueChange(target.value);
    setLocalValue(target.value);
  };

  /* Sync with prop value */
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <InputLabel
      labelText={labelText}
      containerProps={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        className: 'generic-numeric-input-label',
      }}
      captionText={error}
      captionVariant="error"
    >
      <InputV2
        isReadOnly={isReadOnly}
        ref={ref}
        isInvalid={hasError}
        type="number"
        isDashed
        value={localValue}
        onChange={handleLocalValueChange}
        onKeyDown={onKeyDown}
        onBlur={safeOnChange}
        className="generic-numeric-input"
        inputMode="decimal"
      />
    </InputLabel>
  );
};
